import {
  Component,
  OnDestroy,
  OnInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { APIService } from 'src/app/services/api.service';
import { isPlatformBrowser } from '@angular/common';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-public-page',
  templateUrl: './public-page.component.html',
  styleUrls: ['./public-page.component.scss'],
  standalone: false,
})
export class PublicPageComponent {
  logoUrl: any;
  slideInt: any;
  slideInterval = 100;
  infiniteSlide = true;
  selectedIndex = 0;

  imageSize = {
    width: '80px',
    height: '80px',
    space: 12,
  };
  imageSizeMobile = {
    width: '58px',
    height: '58px',
    space: 6,
  };

  autoSlide = { interval: 1, stopOnHover: true };

  userCards: any = [
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-male-icon.png',
      name: 'Mr. Jai Singh, Principal',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `I was initially hesitant to take the software due to no technical knowledge, but within few days of using it, Inforida team has made me comfortable with the software and now I am so much dependent on it while managing my institution.`,
    },
    {
      imgsrc:
        'https://res.cloudinary.com/inforida-in/image/upload/c_scale,h_105/v1524555310/user-female-icon.png',
      name: 'Mrs. Shivani Awasthi, Principal',
      school: 'Sanik Sanjeevani Public School, Sitapur',
      description: `The most economical and user friendly School Management System, Our School Staff is using it from past three years and found it surprisingly easy to use. The interface for School Admin, Accountant, Teachers, parents and student is attractive and very easy to follow.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/sakal.png',
      name: 'Mr. Sanjay Singh, Owner',
      school: 'Sakalnarayan Memorial Public School, Raebareli',
      description: `Our school was loosing ₹10-15 Lacks every acedemic session.
      Thanks to Inforida now I can manage, view and download all financial reports in one click from anywhere. We are using Inforida from last 4 years and never had any problems.`,
    },
    {
      imgsrc: 'https://my.inforida.com/assets/images/mkd.png',
      name: 'Mr. Priyansh Dixit, Owner',
      school: 'Saraswati Shishu Mandir, Lakhimpur',
      description: `The customer support team is super fast and attempts to solve every query/issue. Very easy to use, great school management system with an innovative approach for every problem faced in school administration.
      `,
    },
  ];

  paublicFeatures = [
    {
      imageUrl: '../../../assets/images/imagepp-1.png',
      heading: 'Admission lead Capture',
      description:
        'Collect and manage prospective student Admission data effortlessly',
    },
    {
      imageUrl: '../../../assets/images/imagepp-2.png',
      heading: 'Showcase People',
      description: 'Highlight your staff, studen, & achievement beautifully',
    },
    {
      imageUrl: '../../../assets/images/imagepp-3.png',
      heading: 'Easy Website Customization',
      description:
        'Update your school’s website in real-time with endless customizability without any hassle.',
    },
    {
      imageUrl: '../../../assets/images/imagepp-4.png',
      heading: 'visitor Appointment',
      description: 'Schedule and track school visits with ease.',
    },
  ];

  infraCards = [
    {
      url: '../../../assets/images/infra-1.png',
    },
    {
      url: '../../../assets/images/infra-2.png',
    },
    {
      url: '../../../assets/images/infra-3.png',
    },
    {
      url: '../../../assets/images/infra-4.png',
    },
    {
      url: '../../../assets/images/infra-5.png',
    },
    {
      url: '../../../assets/images/infra-6.png',
    },
  ];

  images1 = [
    {
      url1: '../../../assets/images/image-1.png',
      url2: '../../../assets/images/image-2.png',
    },
    {
      url1: '../../../assets/images/image-3.png',
      url2: '../../../assets/images/image-4.png',
    },
    {
      url1: '../../../assets/images/image-5.png',
      url2: '../../../assets/images/image-6.png',
    },
  ];

  lottieTree: AnimationOptions = {
    path: '../../../assets/lottie/public-page.json',
  };

  constructor(
    private deviceService: DeviceDetectorService,
    public apiService: APIService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.getLogo();
    if (isPlatformBrowser(this.platformId)) {
      this.slideInt = setInterval(() => {
        this.nextslide();
      }, this.slideInterval);
    }
  }

  ngOnDestroy(): void {
    if (this.slideInt) {
      clearInterval(this.slideInt);
    }
  }

  getLogo() {
    this.apiService.getSchoolLogo().subscribe((res: any) => {
      this.logoUrl = res;
    });
    if (this.logoUrl.length) {
      let thumbSize = 'h_280,w_360';
      let finalSize = 'h_800';

      this.logoUrl = this.logoUrl.map((img: any) => {
        img.thumbImage = this.transformImageSize(img.url, thumbSize);
        img.image = this.transformImageSize(img.url, finalSize);
        img.alt = '';
        img.title = '';
        return img;
      });
    }
  }

  transformImageSize(url, size) {
    if (url && url.length && url.includes('cloudinary')) {
      const urlSplit = url.split('/upload/');
      return `${urlSplit[0]}/upload/${size}/${urlSplit[1]}`;
    }
    return url;
  }

  nextslide() {
    if (this.selectedIndex === this.userCards.length - 1) {
      this.selectedIndex = 0;
    } else {
      this.selectedIndex = this.selectedIndex + 1;
    }
  }

  animationCreated(animationItem: AnimationItem): void {
    animationItem.setSpeed(8);
    console.log(animationItem);
  }

  getImgSize() {
    if (this.isMobile()) {
      return this.imageSizeMobile;
    } else {
      return this.imageSize;
    }
  }

  isMobile(): boolean {
    return this.deviceService.isMobile();
  }
}
